/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flow_0_0_2, getSelectedItemOne } from '@flexus/core';
import { environment } from 'apps/studio/src/environments/environment';
import { filter, switchMap, take } from 'rxjs';

export const PGG_DELETE_DRAFT: Flow_0_0_2 = {
	id: 'DeleteDraft',
	itemType: 'flow',
	name: 'DELETE DRAFT',
	includeForOnlyStates: [8],
	includeForOnlyRoles: [1, 18],
	footer: {
		type: 'node_nav'
	},
	startNode: 'DeleteDraft',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: () => {
		return () => {
			return [{}];
		};
	},
	nodes: {
		DeleteDraft: {
			component: 'FLXSuccessTickComponent',
			serverCalls: {
				deleteDraftResponse: {
					errorMessage: 'Draft could not be deleted',
					directCall: (http, store) => {
						return store.select(getSelectedItemOne).pipe(
							filter(Boolean),
							take(1),
							switchMap((claim: any) => {
								return http.post(`${environment.api_url}v1/claim_action/update_claim/`, {
									claim_id: claim?.id,
									new_state: 9
								});
							})
						);
					}
				}
			}
		}
	},
	bigFormToStoreMapper: {}
};
